import isEmpty from 'lodash/isEmpty';

const processSuggestResponse = (airports = [], stations = []) => {
  if (!isEmpty(airports[0])) {
    // eslint-disable-next-line no-param-reassign
    airports[0].$groupStarter = true;
  }
  if (!isEmpty(stations[0])) {
    // eslint-disable-next-line no-param-reassign
    stations[0].$groupStarter = true;
  }

  return [...airports.map((airport) => ({ ...airport, isAirport: true })), ...stations];
};

export default processSuggestResponse;
